<template>
  <div class="d-flex flex-column">
    <a
      v-for="(action, index) in filteredActions"
      :key="index"
      href="#"
      @click.prevent="handleClick(action)"
      class="bosch-panel-action"
    >
      <span :class="action.icon" class="mr-1 d-flex align-items-center"></span>
      <span>{{ action.name }}</span>
    </a>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { useDeviceMessages } from "./composables/useDeviceMessages";
import axios from "@axios";

export default {
  name: "BoschPanel",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
    timeout: Number,
    source: {
      type: String,
      default: "default",
    },
  },
  setup(props) {
    const { confirmActionAlert, successAlertAction, errorAlertAction, showToast } =
      useDeviceMessages(props.trans);
    const localLoading = ref(false);

    const filteredActions = computed(() => {
      if (!props.device?.actions) return [];

      const filtered = props.device.actions.filter(action =>
        action.name === "Alarm silence" || action.name === "Sensor reset"
      );

      return filtered.sort((a, b) => {
        const actionOrder = {
          'Sensor reset': 1,
          'Alarm silence': 2
        };
        return (actionOrder[a.name] || 99) - (actionOrder[b.name] || 99);
      });
    });

    const handleClick = async (action) => {
      const result = await confirmActionAlert(props.device, action);

      if (!result.isConfirmed) return;

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const urlAction = action.data.url;

        await axios.get(urlAction);

        props.updateStatus();

        successAlertAction(props.device, action);

        setTimeout(() => {
          if (props.updateStatus) {
            props.updateStatus();
          }
        }, props.timeout);
      } catch (error) {
        console.error(
          `error in request for device ${props.device.text}:`,
          JSON.stringify(error)
        );
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    return { handleClick, localLoading, filteredActions };
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";
.bosch-panel-action {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 4px;
  .dark-layout & {
    color: $theme-dark-headings-color;
    &:hover {
      color: $theme-dark-label-color;
    }
  }
}
</style>
